import { component } from 'picoapp';
import $ from 'jquery';
import { TimelineMax } from 'gsap/all';
//const plugins = [CSSPlugin];
import str2json from '../../utils/str2json';
const delegate = require('delegate');

class Dropdown {
  constructor(el, ctx) {
    this.isActive = false;
    this.ctx = ctx;
    this.identifier = el.dataset.identifier;
    this.init(el);
    this.initAnimations();
    this.bindEvents();
  }

  init(el) {
    this.el = el;

    // Cache DOM queries
    this.dropdown = el.querySelector('.Dropdown__contents');
    this.trigger = el.querySelector('.Dropdown__trigger');
    this.triggerLabel = el.querySelector('.Dropdown__triggerLabel');

    // Options
    const defaults = {
      replaceTriggerContent: false
    };
    const instanceOptions = str2json(this.el.dataset.options);
    this.options = { ...defaults, ...instanceOptions };
    // console.log(this.options);
  }

  initAnimations() {
    const dropdown = this.dropdown;
    // const options = Array.from(this.dropdown.querySelector('.Nav').children);

    this.tl = new TimelineMax({
      paused: true,
      onComplete: () => {
        this.isActive = true;
      },
      onReverseComplete: () => {
        this.isActive = false;
      }
    });

    this.tl.set(dropdown, {
      display: 'block',
      // x: '-50%',
      immediateRender: false
    });
    this.tl.from(dropdown, 0.15, {
      opacity: 0,
      ease: Elastic.easeOut.config(1, 0.75)
    });
  }

  bindEvents() {
    this.ctx.on('toggle', (state) => {
      if (state.identifier == this.identifier) {
        this.toggle();
      }
    });

    this.el.addEventListener('click', (e) => {
      e.preventDefault();
      this.toggle();
    });

    // Close modal with ESC key
    $(document).keyup((e) => {
      if (e.keyCode == 27 && this.isActive) {
        // escape key maps to keycode `27`
        this.close();
      }
    });

    delegate(
      this.el,
      '.Nav__item',
      'click',
      (e) => {
        // e.preventDefault();
        this.handleOptionClick(e.delegateTarget);
      },
      false
    );
  }

  handleOptionClick(target) {
    // console.log(target);
    if (this.options.replaceTriggerContent && this.triggerLabel) {
      this.triggerLabel.innerHTML = target.innerHTML;
    }
  }

  toggle() {
    // Bailout if toggle component is disabled
    if (this.disabled) {
      return;
    }
    if (this.isActive) {
      this.close();
    } else {
      this.open();
    }
  }

  open() {
    const isActive = new CustomEvent('isActive');
    if (this.isActive) {
      return;
    }
    this.tl.play();
    this.el.dispatchEvent(isActive);
  }

  close() {
    const isInactive = new CustomEvent('isInactive');
    if (!this.isActive) {
      return;
    }
    this.tl.reverse();
    this.el.dispatchEvent(isInactive);
  }
}

// export default Dropdown;
export default component((node, ctx) => {
  new Dropdown(node, ctx);
});
